import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TaskToDoIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
			{...props?.innerSvgProps}
		>
			<g
				clipPath='url(#clip0_25772_279275)'
			>
				<path
					d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
					stroke='#4D4D4D'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath
					id='clip0_25772_279275'
				>
					<rect
						fill='white'
						height='20'
						width='20'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default TaskToDoIcon;
